export default __webpack_public_path__ + "static/media/Twitch.b6ddcdef.png";